import React from 'react'
import ProjectStep from "../components/ProjectStep";
import {Checkbox} from "antd";

export default class LocationStep extends ProjectStep {

    static TranslationKey = 'location_step';

    static path = '/location';
    static slug = 'location';

    static ValidationMethodName = 'validateLocation';

    static StepName = 'Location Preferences';

    static hasCompleted(project)
    {
        return project.validateLocation();
    };

    /**
     * @param {project} project
     * @returns {Object}
     */
    static reviewMapping(project)
    {
        let isService = project.isService();

        let fields = {
            ['Location']: TB.get(project, 'location.full', 'N/A'),
        };
        // if (isService) {
        //     fields['Requires On-Site Team'] = TB.isDefined(project.avg_onsite_days_per_week)
        //         && parseInt(project.avg_onsite_days_per_week) > 0
        //             ? `Yes, ${project.avg_onsite_days_per_week} days/week (minimum)`
        //             : 'No';

        //     fields['Team Location Preference'] = project.allow_remote_team
        //         ? 'Allow Remote'
        //         : 'Local Teams Only';
        // }

        return {
            ['Project Location']: fields,
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {

        let isService =  this.props.project.isService();
        let requires_onsite_team = this.props.project.requires_onsite_team;

        console.log('formFields', this.props.project?.location, TB.auth().user()?.clientOrg()?.location)
        return [
            {
                header: this.translate('location_step_label'),
                fields: {
                    location: {
                        label: this.translate('location_question'),
                        reviewLabel: this.translate('location_review_label'),
                        type: 'location',
                        required: true,
                        validationErrors: this.defaultRequiredValidation(TB.toLower(this.translate('location_step_label')))
                    },
                    defaultLocation: (!this.props.project.setup_at && TB.auth().user()?.clientOrg()?.location) ? (
                        <Checkbox
                            checked={!!this.props.project?.location && this.props.project?.location?.full === TB.auth().user()?.clientOrg()?.location?.full}
                            onChange={async (e) => {
                                let updates = {location: e.target.checked ? TB.auth().user()?.clientOrg()?.location : undefined}
                                await this.onChange(updates)

                                this.formRef.current.updateInputsWithValue(updates)
                            }}
                        >
                            Use my company's default location? <span className="italic text-info">{TB.auth().user()?.clientOrg()?.location.full}</span>
                        </Checkbox>
                    ) : null
                }
            },
            // isService && {
            //     header: 'On-Site Preference',
            //     fields: {
            //         requires_onsite_team: {
            //             label: this.translate('allow_remote_team_question'),
            //             reviewLabel: this.translate('allow_remote_team_review_label'),
            //             type: 'boolean',
            //             required: true,
            //             validationErrors: this.defaultRequiredValidation('on-site preference')
            //         },
            //         avg_onsite_days_per_week: requires_onsite_team && {
            //             label: 'Average days per week (minimum)',
            //             type: 'number',
            //             max: 7,
            //             required: TB.isDefined(requires_onsite_team) && !!requires_onsite_team,
            //             placeholder: 'Enter avg number of days',
            //             min: 1,
            //             validation: {
            //                 rules: {
            //                     matchRegexp: /^[1-7]$/,
            //                     isInt: true
            //                 },
            //                 errors: {
            //                     isInt: TB.trans('validation.integer', {
            //                         'attribute': 'average on-site days'
            //                     }),
            //                     matchRegexp: 'The average on-site days must be between 1 and 7 days.',
            //                 }
            //             },
            //             validationErrors: this.defaultRequiredValidation('average days per week')
            //         },
            //     }
            // },
            // isService && {
            //     header: 'Team Location',
            //     fields: {
            //         allow_remote_team: {
            //             label: 'I am willing to consider a remote team in another city.',
            //             reviewLabel: this.translate('allow_remote_team_review_label'),
            //             type: 'boolean',
            //             required: true,
            //             validationErrors: this.defaultRequiredValidation('team location preference')
            //         }
            //     }
            // }
        ];
    };
}